import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Swiper, SwiperSlide } from "../Swiper";

import "../ContentCard/styles.css";
import "swiper/swiper.min.css";
import "./styles.css";

interface ContentCardsSkeletonProps {
  count?: number;
  layout?: "grid" | "row";
  showTitle?: boolean;
}

const skeletonColors = {
  baseColor: "var(--portal-skeleton-base)",
  highlightColor: "var(--portal-skeleton-highlight)",
};

const ContentCardsSkeleton = ({
  count = 6,
  layout = "grid",
  showTitle = true,
}: ContentCardsSkeletonProps) => {
  const placeholders = Array.from({ length: count }, (_, index) => (
    <article
      className="content-card content-cards-skeleton__card"
      key={index}
    >
      <div className="content-card__image content-cards-skeleton__image">
        <Skeleton
          {...skeletonColors}
          borderRadius={15}
          className="content-cards-skeleton__image-fill"
          containerClassName="content-cards-skeleton__image-container"
        />
      </div>
      <div className="content-card__heading content-cards-skeleton__heading">
        <div className="content-cards-skeleton__name">
          <Skeleton
            {...skeletonColors}
            borderRadius={6}
            className="content-cards-skeleton__name-line"
          />
          <Skeleton
            {...skeletonColors}
            borderRadius={6}
            className="content-cards-skeleton__name-line content-cards-skeleton__name-line--short"
          />
        </div>
        <div className="content-card__rating content-cards-skeleton__rating">
          <Skeleton
            {...skeletonColors}
            circle
            className="content-cards-skeleton__rating-icon"
          />
          <Skeleton
            {...skeletonColors}
            borderRadius={6}
            className="content-cards-skeleton__rating-value"
          />
        </div>
      </div>
      <div className="content-card__footer content-cards-skeleton__footer">
        <div className="content-card__metadata-list">
          <div className="content-card__metadata content-cards-skeleton__metadata">
            <Skeleton
              {...skeletonColors}
              circle
              className="content-cards-skeleton__metadata-icon"
            />
            <Skeleton
              {...skeletonColors}
              borderRadius={6}
              className="content-cards-skeleton__metadata-text"
            />
          </div>
        </div>
        <Skeleton
          {...skeletonColors}
          borderRadius={6}
          className="content-cards-skeleton__details"
          containerClassName="content-cards-skeleton__details-container"
        />
      </div>
    </article>
  ));

  return (
    <section
      className="content-cards-skeleton"
      aria-label="Carregando conteúdos"
      aria-busy="true"
    >
      {showTitle && (
        <Skeleton
          {...skeletonColors}
          borderRadius={8}
          className="content-cards-skeleton__title"
        />
      )}

      {layout === "row" ? (
        <Swiper
          className="content-card-list__carousel"
          cssMode
          slidesPerView={1.17}
          spaceBetween={22}
          breakpoints={{
            721: { slidesPerView: 2.16, spaceBetween: 42 },
            1121: { slidesPerView: 3.18, spaceBetween: 58 },
          }}
          watchOverflow
        >
          {placeholders.map((placeholder, index) => (
            <SwiperSlide key={index}>{placeholder}</SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className="content-card-list__grid">{placeholders}</div>
      )}
    </section>
  );
};

export default ContentCardsSkeleton;
